export default __webpack_public_path__ + "static/media/battleship.3871d4a8.jpg";